import React from "react";
import PropTypes from "prop-types";
import { Label } from "reactstrap";
import { Field, ErrorMessage } from "formik";

const RavenFormikSelectComp = ({
  name,
  label,
  valueList,
  divClassName,
  getDescription,
  getClassNameValue,
  disabled,
  placeholder,
  defaultOption,
}) => {
  return (
    <div id={name + "_div"} className={divClassName || "mb-3"}>
      <Label className="form-label">{label}</Label>
      <Field
        name={name}
        component="select"
        className={getClassNameValue}
        disabled={disabled}
        placeholder={placeholder}
      >
        <option value="">{defaultOption}</option>
        {valueList.map(item => (
          <option key={item.guid} value={item.guid}>
            {getDescription(item)}
          </option>
        ))}
      </Field>
      <ErrorMessage name={name} component="div" className="invalid-feedback" />
    </div>
  );
};

RavenFormikSelectComp.propTypes = {
  name: PropTypes.any,
  label: PropTypes.any,
  valueList: PropTypes.any,
  divClassName: PropTypes.any,
  disabled: PropTypes.bool,
  placeholder: PropTypes.any,
  getDescription: PropTypes.func,
  getClassNameValue: PropTypes.any,
  defaultOption: PropTypes.string,
};

export default RavenFormikSelectComp;
